function validateStringLength(str: string, min: number, max: number): boolean {
  if (!str) return false;

  return str.length >= min && str.length <= max;
}

export default validateStringLength;
